import React from "react";
import { PortableText } from "@portabletext/react";
import DownloadSelector from '../DownloadSelector'
 
export default function SystemTabs({tabs}) {
  const [activeTab, setActiveTab] = React.useState(0);

  if (!tabs?.length) return null;

  return (
    <div>
      <div className="flex w-full flex-row rounded-none p-0 text-lg download-bg">
        {tabs.map((tab, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setActiveTab(index)}
            className={
              activeTab === index
                ? "min-w-0 flex-1 text-left text-primary selected-bg z-10 rounded-none p-2 shadow-none"
                : "min-w-0 flex-1 text-left p-2"
            }
          >
            {tab.title}
          </button>
        ))}
      </div>

      {tabs.map((tab, index) =>
        activeTab === index ? (
          <div key={index} className="p-0 text-primary">
            <div className="contentBlock text-left text-lg mt-10">
              <PortableText value={tab.body} />
            </div>
            <DownloadSelector profiles={tab.profiles} />
          </div>
        ) : null
      )}
    </div>
  );
}